import { post_request } from '../axiosFun';

//查询用车列表
export const get_task_list = (params) => {
    params = {
        row:{
            use_name:params.use_name,
            car_id:params.car_id,
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/use_car_manage/get_list",params)
};
//添加
export const get_task_add = (params) => {
    params = {
        row:{
            use_name:params.use_name,
            car_id:params.car_id,
            use_tel:params.use_tel,
            car_location:params.car_location,
            remarks:params.remarks || "",
            start_date:params.date[0],
            end_date:params.date[1]
        }
    }
    return post_request("/web/task_manage/use_car_manage/add",params)
};
//获取单条
export const get_tast_one = (params) => {
    params = {
        row:{
            id:params,
        }
    }
    return post_request("/web/task_manage/use_car_manage/get_one",params)
};
//编辑
export const get_task_edit = (params) => {
    params = {
        row:{
            id:params.id,
            use_name:params.use_name,
            car_id:params.car_id,
            use_tel:params.use_tel,
            car_location:params.car_location,
            remarks:params.remarks || "",
            start_date:params.date[0],
            end_date:params.date[1]
        }
    }
    return post_request("/web/task_manage/use_car_manage/update",params)
};
//获取车辆编号
export const get_car_id_list = (params) => {
    params = {
        row:{
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/use_car_manage/get_car_id_list",params)
};
//修改车辆编号
export const get_car_id_list_update = (params) => {
    params = {
        row:{
            car_id:params.car_id,
            size:params.page,
            limit:params.limit
        }
    }
    return post_request("/web/task_manage/use_car_manage/get_car_id_list_update",params)
};
//删除
export const get_task_del = (params) => {
    params = {
        row:{
            id:params,
        }
    }
    return post_request("/web/task_manage/use_car_manage/del",params)
};


// WEBPACK FOOTER //
// ./src/api/tast/tast.js